const CategoriesRoutes = {
  getAllCategories: "/category/allcategories",
  uploadImage: "/ad/uploadImage",
  createCategory: "/category/categories",
  updateCategory: "/category/update",
  deleteCategory: "/category/delete",
  updateCategorySequence: "/category/updateCategorySequence",
}

export default CategoriesRoutes;